import { ActionType } from '../clients/transaction-clients';

export class ActionTypeValueConverter {
  toView(actionType: ActionType) {
    return ActionType[actionType];
  }
}
